import { Permissions, ServiceInfoDc, TableInfoDc, UserOrRoleDc } from "@evergis/api";
import { AccessControlListDc, ExtendedProjectInfoDc } from "@evergis/api/dist/__generated__/data-contracts";
import { ChipAutoCompleteData } from "@evergis/ui";

export type ProjectStructureLayer = ServiceInfoDc & {
  acl?: AccessControlListDc;
};

export type ProjectStructureTable = TableInfoDc & {
  name: string;
  acl?: AccessControlListDc;
  layers: ProjectStructureLayer[];
};

export type ProjectStructureInfo = ExtendedProjectInfoDc & {
  tables: ProjectStructureTable[];
};

export interface ProjectStructureProps {
  activeAclRole: string;
  structure: ProjectStructureInfo;
  readOnly?: boolean;
  onUpdateProject: (toggle: "read" | "write" | "configure", permissions: Permissions) => void;
  onUpdateEntity: (
    entityName: string,
    entityType: string,
    toggle: "read" | "write" | "configure",
    permissions: Permissions,
  ) => void;
}

export type LayerStructureLayer = ServiceInfoDc & {
  acl?: AccessControlListDc;
};

export type LayerStructureTable = TableInfoDc & {
  name: string;
  acl?: AccessControlListDc;
  layers: LayerStructureLayer[];
};

export type LayerStructureInfo = {
  alias: string;
  tables: LayerStructureTable[];
};

export interface LayerStructureProps {
  activeAclRole: string;
  tables: LayerStructureTable[];
  onUpdateEntity: (
    entityName: string,
    entityType: string,
    toggle: "read" | "write" | "configure",
    permissions: Permissions,
  ) => void;
  readOnly?: boolean;
}

export interface StructureControlProps {
  active?: boolean;
  partial?: boolean;
  clickable?: boolean;
  disabled?: boolean;
}

export interface PartialEntities {
  read: boolean;
  write: boolean;
  configure: boolean;
}

export interface CheckedEntities {
  read: boolean;
  write: boolean;
  configure: boolean;
}

export interface AccessControlProps {
  type: "read" | "write" | "configure";
  active: boolean;
  onClick?: VoidFunction;
  disabled?: boolean;
  partial?: boolean;
  clickable?: boolean;
}

export enum AccessRoleGroup {
  Public = "public",
}

export type ChipDataUser = UserOrRoleDc & Omit<ChipAutoCompleteData, "name">;
